<template>
  <BaseLayout />
</template>

<script setup>
import BaseLayout from '@/components/BaseLayout.vue'
import 'animate.css';

</script>
<style>
:root {
  --bs-primary: #004B6B !important;
  --bs-secondary: #00A9B7 !important;
  --bs-success: #198754 !important;
  --bs-danger: #C62828 !important;
  --bs-light: #F5F5F5 !important;
  --bs-dark: #2E2E2E !important;
}

body {
  font-family: 'Inter', sans-serif;
  color: var(--bs-dark);
  background-color: white;
}
</style>
